import { css } from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';

export const Tooltip = css`
  .with-tooltip {
    position: relative;
    &.active {
      opacity: 1 !important;
    }
  }
  .with-tooltip-active {
    > * {
      opacity: 0.25;
      @media ${mqLargeMin} {
        opacity: 1;
      }
    }
  }
`;
